import { render, staticRenderFns } from "./whatsapp-settings.vue?vue&type=template&id=c1024754"
import script from "./whatsapp-settings.vue?vue&type=script&lang=js"
export * from "./whatsapp-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports